export const CREATEPROFILE_INIT_ACTION = "CREATEPROFILE_INIT";
export const CREATEPROFILE_FAIL_ACTION = CREATEPROFILE_INIT_ACTION + "_ERROR";
export const CREATEPROFILE_SUCCESS_ACTION = CREATEPROFILE_INIT_ACTION + "_SUCCESS";

export const FETCHSTATE_INIT_ACTION = "FETCHSTATE_INIT_ACTION";
export const FETCHSTATE_FAIL_ACTION = FETCHSTATE_INIT_ACTION+"_ERROR";
export const FETCHSTATE_SUCCESS_ACTION = FETCHSTATE_INIT_ACTION+"_SUCCESS";

export const FETCHDISTRICT_INIT_ACTION = "FETCHDISTRICT_INIT_ACTION";
export const FETCHDISTRICT_FAIL_ACTION = FETCHDISTRICT_INIT_ACTION + "_ERROR";
export const FETCHDISTRICT_SUCCESS_ACTION = FETCHDISTRICT_INIT_ACTION + "_SUCCESS";

export const FETCHBANKS_INIT_ACTION = "FETCHBANKS_INIT_ACTION";
export const FETCHBANKS_SUCCESS_ACTION = FETCHBANKS_INIT_ACTION+"_SUCCESS";
export const FETCHBANKS_FAIL_ACTION=FETCHBANKS_INIT_ACTION+"_ERROR";

export function createOrgProfile(value) {
  return {
    type: CREATEPROFILE_INIT_ACTION,
    value: value,
  };
}

export function fetchStates(){
  return{
    type:FETCHSTATE_INIT_ACTION,
  }
}

export function fetchDistricts(value){
  return{
    type:FETCHDISTRICT_INIT_ACTION,
    value:value,
  }
}

export function fetchbanks(){
  return {
    type:FETCHBANKS_INIT_ACTION,
  }
}